import { useState } from 'react'
import { localestr, processFinishTo } from '../utils.js'
import icon from '../icons.svg';
import { PAY_TYPES } from '../constants.js';

function BanquetTab({ userId, cmdClick, Orders, wndData, CourierTrn, Rights, Consts, docType, showMap, showMsg, runCmd }) {
  const [open, setOpen] = useState(true)

  const filter_date = new Date()
  filter_date.setHours(filter_date.getHours() + 2)
  const str_date = filter_date.toISOString()

  let ord = []
  if (Orders) ord = Orders.filter(el => ((el.date || str_date) > str_date)).sort((a, b) => {
    if (a.finish_to && b.finish_to && a.finish_to < b.finish_to) return -1
    if (a.finish_to && b.finish_to && a.finish_to > b.finish_to) return 1
    return 0
  })


  const stl1 = { width: '170px', height: '90px', display: 'table', padding: '4px' }
  const stl2 = { display: 'table-cell', verticalAlign: 'middle', whiteSpace: 'pre-wrap' }
  if (window.innerWidth < 400) stl1.width = 'calc(33% - 10px)'

  let content = ord.map((el, idx) => {
    let ttl2 = (new Date(el.date)).toLocaleString()
    let cap = 'На ' + ttl2.substring(0, 17)
    if (cap) cap += "\n"
    cap += (el.phone || '') + ' ' + (el.name || '')
    if (cap) cap += "\n"
    let cls = ''
    let cantClick = false
    ttl2 = el.advance ? (' ( -' + el.advance + ' )') : ''

    if (el.author.id === userId) {
      cap += el.sum.toFixed(2) + '  ' + ttl2
      cls = 'order'
      if (el.online) cls = 'order2'
    } else {
      if (!Rights.urAdmin && !Rights.urBanquet) cantClick = true
      else cap += el.sum.toFixed(2) + '  ' + ttl2 + "\n"
      cap += el.author ? el.author.name : ''
      cls = 'select'
    }

    if (el.docType === 0) {
      cap += '\n (В закладі)'
    } else if (el.docType === 1) {
      cap += '\n (Доставка)'
    } else if (el.docType === 2) {
      cap += '\n (Самовивіз)'
    }
    
    let ico = null
    if (el.kitch_status) ico = <div style={{ display: 'inline-block', width: '24px', height: '24px', margin: '-2px 0px -5px 3px', backgroundColor: 'var(--tbl1-tx-color)', mask: 'url(' + icon + '#btn4)' }}></div>
    if (el.status > 1) ico = <div style={{ display: 'inline-block', width: '24px', height: '24px', margin: '-2px 0px -5px 3px', backgroundColor: 'var(--tbl1-tx-color)', mask: 'url(' + icon + '#btn24)' }}></div>
    // if (el.finish_to) {
    //   new Date(wndData.finish_to).toLocaleString('uk-UA')
    // }
    if (cantClick) return (<div key={idx} style={stl1}><div className={'button ' + cls} style={stl2}>{cap}</div></div>)
    else return (
      <div key={idx} style={stl1}>
        <div className={'button ' + cls} style={stl2} onClick={() => { cmdClick(el) }}>
          {cap}
          {ico}
        </div>
      </div>)
  })

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', placeContent: 'start', overflow: 'auto' }}>
      <div style={stl1}>
        <div className='button' style={stl2} onClick={() => { cmdClick() }}>
          {localestr('Нове замовлення')}
        </div>
      </div>
      {content}
    </div>
  )
}

export default BanquetTab